import React, { useState } from "react";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const [inputType, setInputType] = useState(type);

  return (
    <div className="relative">
      <input
        type={inputType}
        className={cn(
          "h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file: placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          type === "date" && "w-full pr-8",
          className
        )}
        ref={ref}
        {...props}
      />

      {type === "password" && (
        inputType === "password" ? (
          <EyeIcon
            className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
            onClick={() => setInputType("text")}
            size="1rem"
          />
        ) : (
          <EyeOffIcon
            className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
            onClick={() => setInputType("password")}
            size="1rem"
          />
        )
      )}
    </div>
  );
});

Input.displayName = "Input";

export { Input };
